"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = [{
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'crescent',
    client_id: '07-tendermint-53',
    connection_id: 'connection-52'
  },
  chain_2: {
    chain_name: 'mars',
    client_id: '07-tendermint-14',
    connection_id: 'connection-9'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-35',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-5',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true,
      dex: 'crescent'
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'juno',
    client_id: '07-tendermint-300',
    connection_id: 'connection-270'
  },
  chain_2: {
    chain_name: 'mars',
    client_id: '07-tendermint-11',
    connection_id: 'connection-7'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-209',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-3',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'kujira',
    client_id: '07-tendermint-78',
    connection_id: 'connection-54'
  },
  chain_2: {
    chain_name: 'mars',
    client_id: '07-tendermint-3',
    connection_id: 'connection-2'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-55',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-0',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'mars',
    client_id: '07-tendermint-64',
    connection_id: 'connection-50'
  },
  chain_2: {
    chain_name: 'neutron',
    client_id: '07-tendermint-21',
    connection_id: 'connection-21'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-37',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-16',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'mars',
    client_id: '07-tendermint-4',
    connection_id: 'connection-3'
  },
  chain_2: {
    chain_name: 'osmosis',
    client_id: '07-tendermint-2602',
    connection_id: 'connection-2114'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-1',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-557',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}, {
  $schema: '../ibc_data.schema.json',
  chain_1: {
    chain_name: 'mars',
    client_id: '07-tendermint-10',
    connection_id: 'connection-6'
  },
  chain_2: {
    chain_name: 'terra2',
    client_id: '07-tendermint-104',
    connection_id: 'connection-91'
  },
  channels: [{
    chain_1: {
      channel_id: 'channel-2',
      port_id: 'transfer'
    },
    chain_2: {
      channel_id: 'channel-78',
      port_id: 'transfer'
    },
    ordering: 'unordered',
    version: 'ics20-1',
    tags: {
      status: 'live',
      preferred: true
    }
  }]
}];
var _default = exports["default"] = info;